import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { AppEntryPoint } from "./AppEntryPoint";

function App() {
  return (
    <BrowserRouter>
      <AppEntryPoint />
    </BrowserRouter>
  );
}

export default App;
